import { Button, Dialog, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useWorkspace } from '@/contexts/useWorkspace';
import { handleMpaInterceptInWizard } from '@/data/dal/mpaIntercept';
import { ButtonWithIcon } from '../buttons/buttonWithIcon';
import { LoaderButton } from '../buttons/loaderButton';
import { Icon } from '../shared/icon';
interface ConfirmationDialogProps {
  isOpen: boolean;
  title: React.ReactNode;
  description: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => Promise<void> | void;
  buttonIconClass?: string;
  buttonTitle: string;
  cancelButtonTitle?: string;
  confirmSnackbarText?: string;
  confirmDisabled?: boolean;
}
export function ConfirmationDialog(props: ConfirmationDialogProps) {
  const [error, setError] = useState('');
  const {
    snackbar
  } = useWorkspace();
  const [confirmationInProgress, setConfirmationProgress] = useState(false);
  const onConfirm = async () => {
    setError('');
    setConfirmationProgress(true);
    try {
      await props.onConfirm();
      if (props.confirmSnackbarText) {
        snackbar.showMessage(props.confirmSnackbarText);
      }
    } catch (error_0) {
      if (handleMpaInterceptInWizard(error_0, props.onCancel, snackbar)) {
        return;
      }
      const err = error_0 as Error;
      setError(err.message);
      throw err;
    } finally {
      setConfirmationProgress(false);
    }
  };

  // reset error message when dialog is closed
  useEffect(() => {
    if (props.isOpen) {
      setError('');
      setConfirmationProgress(false);
    }
  }, [props.isOpen]);
  return <Dialog open={props.isOpen} slotProps={{
    paper: {
      sx: {
        width: 'max-content',
        maxWidth: '840px',
        minWidth: '600px',
        height: 'max-content',
        maxHeight: '90vh',
        borderRadius: '16px'
      }
    }
  }}>
      <Stack data-testid='confirmation-dialog'>
        <Stack direction='row' sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px',
        paddingBottom: '0'
      }}>
          <div></div>
          <Icon onClick={props.onCancel} iconClass='material-symbols-close-rounded' />
        </Stack>
        <Stack sx={{
        alignItems: 'center',
        gap: '12px',
        px: '40px',
        textAlign: 'center',
        pb: '40px'
      }}>
          {typeof props.title === 'string' ? <Typography variant='h2'>{props.title}</Typography> : props.title}
          <Typography variant='body1' className='mb-[12px]' sx={{
          maxWidth: '70%',
          lineHeight: '20px'
        }}>
            {props.description}
          </Typography>
          <Stack direction='row' sx={{
          gap: '12px'
        }}>
            <Button onClick={props.onCancel}>
              {props.cancelButtonTitle ?? 'Cancel'}
            </Button>
            {!confirmationInProgress ? <ButtonWithIcon onClick={() => void onConfirm()} icon={props.buttonIconClass} text={props.buttonTitle} variant='outlined' disabled={props.confirmDisabled} /> : <LoaderButton />}
          </Stack>
        </Stack>
        {error && <Typography variant='body1' sx={{
        color: 'error.main',
        padding: '0 0 16px 24px'
      }}>
            {error}
          </Typography>}
      </Stack>
    </Dialog>;
}